"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.coinselect = void 0;
const accumulative_1 = require("./inputs/accumulative");
const bnb_1 = require("./inputs/bnb");
const utils_1 = require("./utils");
const tryconfirmed_1 = require("./tryconfirmed");
function coinselect(inputs, outputs, feeRate, options) {
    const sortedInputs = options.skipPermutation ? inputs : inputs.sort((0, utils_1.sortByScore)(feeRate));
    const algorithm = (0, tryconfirmed_1.tryConfirmed)((0, utils_1.anyOf)([(0, bnb_1.bnb)(0.5), accumulative_1.accumulative]), options);
    return algorithm(sortedInputs, outputs, feeRate, options);
}
exports.coinselect = coinselect;
